import type { TrailStep } from '@argink/ui';

/**
 * Mapeia uma lista de rótulos + índice corrente para os `TrailStep[]` que o
 * `TrailStepper` de `@argink/ui` espera — mesma semântica do antigo
 * `ProgressSteps` local (pending/current/done por posição), agora sobre o
 * componente de marca em vez de uma segunda interpretação da trilha.
 *
 * Não existe status "erro" no `TrailStepper` (decisão do design system: a
 * trilha é progresso de navegação, não prova — ver `packages/ui/README.md`).
 * O estado de falha é sempre comunicado por um `Alert`/`StateCard` adjacente,
 * nunca só pela cor do nó — consistente com "status nunca só por cor".
 */
export function buildLinearTrailSteps(labels: readonly string[], currentIndex: number): TrailStep[] {
  return labels.map((label, index) => ({
    id: `step-${index}`,
    label,
    status: index < currentIndex ? 'done' : index === currentIndex ? 'current' : 'pending',
  }));
}
